import { render, staticRenderFns } from "./QuestionsStep.vue?vue&type=template&id=06cc0afe"
import script from "./QuestionsStep.vue?vue&type=script&lang=js"
export * from "./QuestionsStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports